import React from 'react';
import SignInForm from 'modules/SignIn/components/SignInForm';
import usePageMeta from '../hooks/usePageMeta';

const SignIn: React.FC = (): JSX.Element => {
  usePageMeta({
    title: 'Sign In — BoostHiring',
    description:
      'Sign in to your BoostHiring account to manage job posts, review candidates, and connect with recruiters.',
    canonical: 'https://boosthiring.ca/signin',
    noindex: true,
  });

  return <SignInForm />;
};

export default SignIn;
